"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Crumb = void 0;
var react_1 = __importStar(require("react"));
var Typography_1 = __importDefault(require("../Typography"));
var Icon_1 = __importDefault(require("../Icon"));
var react_jss_1 = require("react-jss");
var classnames_1 = __importDefault(require("classnames"));
var useStyles = (0, react_jss_1.createUseStyles)(function (theme) { return ({
    label: {
        cursor: function (props) { return (props.onClick ? 'pointer' : 'default'); },
    },
    arrow: {
        margin: "0 ".concat(theme.margins.sm, "px"),
    },
}); });
var Crumb = function (props) {
    var styles = useStyles(props);
    var children = props.children, active = props.active, completed = props.completed, withArrow = props.withArrow, className = props.className, color = props.color, rest = __rest(props, ["children", "active", "completed", "withArrow", "className", "color"]);
    var statusColor = (0, react_1.useMemo)(function () {
        if (color)
            return color;
        return active ? 'Grey@900' : completed ? 'Green@600' : 'Grey@500';
    }, [active, completed]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Typography_1.default, __assign({ uppercase: true, variant: 'textSmall', color: statusColor, weight: 'bold', className: (0, classnames_1.default)(styles.label, className) }, rest), children),
        withArrow && (react_1.default.createElement(Icon_1.default, { name: 'arrowForward', size: 'sm', color: statusColor, className: styles.arrow }))));
};
exports.Crumb = Crumb;
//# sourceMappingURL=Crumb.js.map